export const NO_ACCESS = 1;
export const VIEWER = 2;
export const EDITOR = 3;

export const RESP_GROUP_UNIT = 1;
export const RESP_GROUP_PLANNING = 2;
export const RESP_GROUP_COSTCENTER = 3;
export const RESP_GROUP_WORKCENTER = 4;

export const ESSENTIAL = 'essential';
export const NON_ESSENTIAL = 'non-essential';

export const MAX_IMAGE_BYTES = 20 * 1024 * 1024; // 20 MB
export const MAX_PDF_BYTES = 20 * 1024 * 1024; // 20 MB
